import TrackingCategoriesEdit from './TrackingCategoriesEdit';
import blankRAViews from '../../components/BlankRAViews';

export default {
  ...blankRAViews,
  edit: TrackingCategoriesEdit,
};
